import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Project } from '@src/app/models/project';
import { Customer } from '../customer-control/model/customer';
import { CustomerprojectlistService } from './service/customerprojectlist.service';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Router } from '@angular/router';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { Subscription } from 'rxjs';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-customerprojectlist',
  templateUrl: './customerprojectlist.component.html',
  styleUrls: ['./customerprojectlist.component.css']
})
export class CustomerprojectlistComponent implements OnInit {
  @Input() customer:Customer;
  customerProjectList:Project[] = [];
  customerRawProjectList:Project[] = [];
  dataStoreSubscription:Subscription;

  constructor(
    private cplsrv:CustomerprojectlistService, 
    private router:Router,
    private auth:AuthorizationService,
    private datastore:DatastoreService) { 
      this.dataStoreSubscription = this.datastore.projectList$.pipe(untilDestroyed(this)).subscribe(data => {
        this.customerRawProjectList = Array.isArray(data) ? data : [];
        this.refreshCustomerProjects();
      });
    }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.customer?.currentValue?.customerId){
      this.refreshCustomerProjects();
    }
  }

  ngOnInit() {
    this.refreshCustomerProjects();
  }
  ngOnDestroy(): void {
    if (this.dataStoreSubscription) this.dataStoreSubscription.unsubscribe();
    
  }
  showWorkOnProject(proj:Project){
    return this.auth.isAuthorized('projectview',proj.projectId);
  }
  gotoWorkOnProject(proj:Project){
    SessionHelper.setCurrentProject(proj.projectId);
    SessionHelper.setCurrentProjectName(proj.title);
    SessionHelper.setCurrentProjectFull(JSON.stringify(proj));
    this.router.navigate(['/portal/project/'+proj.projectId]);
  }

  private normalizeCustomerKey(value: string): string {
    return String(value || '').trim().split('_')[0] || '';
  }

  private refreshCustomerProjects(): void {
    const customerId = String(this.customer?.customerId || '').trim();
    if (!customerId) {
      this.customerProjectList = [];
      return;
    }

    const normalizedCustomerKey = this.normalizeCustomerKey(customerId);
    this.customerProjectList = this.customerRawProjectList.filter((project) => {
      const projectCustomer = String(project?.customer || '').trim();
      if (!projectCustomer) {
        return false;
      }

      const normalizedProjectKey = this.normalizeCustomerKey(projectCustomer);
      return projectCustomer === customerId
        || projectCustomer.startsWith(`${customerId}_`)
        || normalizedProjectKey === normalizedCustomerKey;
    });
  }
  
}
